/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompanyEditModel { 
    companyId?: number;
    companyCode?: string;
    companyName?: string;
    companyShortName?: string;
    invoiceNumber?: string;
    registerAddress?: string;
    contactAddress?: string;
    financeCurrency?: string;
    amountError?: number;
    validPlaces?: number;
    parentCompanyId?: number;
    ifrstax?: string;
    englishName?: string;
    englishAddress?: string;
    telephone?: string;
    fax?: string;
    updateUserNo?: string;
    updateTime?: Date;
}